import { Container, ICanvas } from "pixi.js";
import { ITransform } from "./ITransform";

export class Camera implements ITransform {
	public readonly container: Container = new Container({sortableChildren: true});

	constructor(parent: Container, private readonly canvas: ICanvas) {
		parent.addChild(this.container);
	}

	public tick(deltaMS: number, target: ITransform) {
		// Move if player gets close to screen border.
		// let distanceToLeft = target.x - this.x;
		// let distanceToRight = (this.x + this.w) - target.x;
		// let distanceToTop = target.y - this.y;
		// let distanceToBottom = (this.y + this.h) - target.y;
		// let maxDistance = 300;
		// if (distanceToLeft < maxDistance) this.x -= maxDistance - distanceToLeft;
		// if (distanceToRight < maxDistance) this.x += maxDistance - distanceToRight;
		// if (distanceToTop < maxDistance) this.y -= maxDistance - distanceToTop;
		// if (distanceToBottom < maxDistance) this.y += maxDistance - distanceToBottom;

		// Center camera on player.
		this.x = Math.round(target.x - this.w / 2);
		this.y = Math.round(target.y - this.h / 2);
	}

	public destroy() {
		this.container.removeFromParent();
	}

	// region ITransform

	public get x(): number {
		return -this.container.x;
	}

	public set x(value: number) {
		this.container.x = -value;
	}

	public get y(): number {
		return -this.container.y;
	}

	public set y(value: number) {
		this.container.y = -value;
	}

	public get w(): number {
		return this.canvas.width;
	}

	public get h(): number {
		return this.canvas.height;
	}

	// endregion
}
